import {TableCell} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import CommonTheme from '../../../../../Theme';

export const HeaderCell = withStyles((theme) => ({
  root: {
    backgroundColor: CommonTheme.palette.grid.main,
    color: CommonTheme.palette.primary.contrastText,
  },
}))(TableCell);

export const MergedCell = withStyles((theme) => ({
  root: {
    backgroundColor: CommonTheme.palette.grid.light,
    color: CommonTheme.palette.grid.contrastText,
    paddingRight: '8px',
  },
}))(TableCell);

export const MiniHeaderCell = withStyles((theme) => ({
  root: {
    padding: '3px 6px',
  },
}))(HeaderCell);
